export const getContentType = (file: File) => {
  const fileNameSplit = file.name.split('.');
  const extension = fileNameSplit[fileNameSplit.length - 1] || '';

  return file.type || 'image/x-' + extension;
};
